(function () {
  // ---- Settings
  const START_DELAY_MS = 400;   // initial delay before first run
  const RECHECK_MS     = 300;   // retry interval while Junip loads
  const MAX_TRIES      = 30;    // retries before relying on observer

  const COUNT_SELECTOR = '.junip-product-summary-review-count';
  const FLAG_ATTR      = 'data-junip-count-formatted';

  function formatCounts(root = document) {
    const els = root.querySelectorAll(COUNT_SELECTOR);
    if (!els.length) return false;

    els.forEach((el) => {
      // If Junip re-renders, it's a new node, so this runs again (good)
      if (el.getAttribute(FLAG_ATTR) === '1') return;

      const raw = (el.textContent || '').trim();  // e.g. "(5)" or "( 5 )"
      const count = parseInt(raw.replace(/\D/g, ''), 10);
      if (Number.isNaN(count)) return;

      const word = count === 1 ? 'review' : 'reviews';

      // Write it INSIDE the parentheses exactly as requested
      el.textContent = `(${count} ${word})`;

      el.setAttribute(FLAG_ATTR, '1');
    });

    return true;
  }

  function startObserver() {
    const target = document.body;
    if (!target) return;

    const observer = new MutationObserver(() => {
      // Re-apply whenever Junip updates/rehydrates
      formatCounts(document);
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  // Start after initial delay
  setTimeout(() => {
    let tries = 0;

    const tick = () => {
      tries++;
      formatCounts(document);

      if (tries < MAX_TRIES) {
        setTimeout(tick, RECHECK_MS);
      }
    };

    tick();
    startObserver();
  }, START_DELAY_MS);
})();